declare global {
  interface Window {
    clarity?: (...args: any[]) => void;
  }
}

export const CLARITY_PROJECT_ID = 'w7dygqd3hl';
export const CLARITY_PROJECT_ID_N2N = 'w7e2751evf';

let clarityBootstrappedProjectId: string | null = null;

/**
 * Injects Microsoft Clarity tag script into the page once.
 *
 * Intended usage: mount only on routes that should be tracked (e.g. `/qq/*`).
 */
export function ensureClarityLoaded(projectId: string = CLARITY_PROJECT_ID) {
  if (typeof window === 'undefined') return;

  if (clarityBootstrappedProjectId === projectId) return;

  const existingScript = document.querySelector<HTMLScriptElement>(
    'script[data-clarity-project-id]',
  );

  // If a clarity tag is already injected (by us or something else), don't re-inject.
  if (existingScript || typeof window.clarity === 'function') {
    const existingId =
      existingScript?.getAttribute('data-clarity-project-id') ?? null;

    // If we can detect that it's already the expected ID, mark as bootstrapped.
    if (!existingId || existingId === projectId) {
      clarityBootstrappedProjectId = projectId;
      return;
    }

    // Otherwise, avoid injecting a second Clarity tag (Clarity supports one project per page).
    // eslint-disable-next-line no-console
    console.warn(
      `[Clarity] A different project id is already installed (${existingId}); skipping injection of ${projectId}.`,
    );
    return;
  }

  // Based on the official snippet:
  // https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-setup
  // eslint-disable-next-line func-names
  (function (
    c: any,
    l: Document,
    a: string,
    r: string,
    i: string,
    t?: any,
    y?: any,
  ) {
    c[a] =
      c[a] ||
      function () {
        // eslint-disable-next-line prefer-rest-params
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = `https://www.clarity.ms/tag/${i}`;
    t.setAttribute('data-clarity-project-id', i);
    y = l.getElementsByTagName(r)[0];
    y.parentNode!.insertBefore(t, y);
  })(window, document, 'clarity', 'script', projectId);

  clarityBootstrappedProjectId = projectId;
}
